import {
  SET_DEPARTMENTS,
  SET_DEPARTMENT_LIST,
  SET_DEPARTMENT_FILTER_LIST,
  SET_SELECTED_DEPARTMENT,
} from './actions';
import { merge } from '@its/util';

export default (state = [], action) => {
  switch (action.type) {
    case SET_DEPARTMENTS:
      return merge(state, { items: action.payload });
    case SET_DEPARTMENT_LIST:
      return merge(state, { list: action.payload });
    case SET_DEPARTMENT_FILTER_LIST:
      return merge(state, { filterList: action.payload });
    case SET_SELECTED_DEPARTMENT:
      return merge(state, { detail: action.payload });
    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/department/reducer.js
 **/